// extracted by mini-css-extract-plugin
export default {"my_profile_tab":"my_profile_tab___GUBUU","header":"header___VdgFB","details":"details___gNgK9","detail":"detail___IHdfO"};